import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '../theme/aikya';
import { Header }  from './Header';
import { PageWrapper } from './PageWrapper';
import { PartsSection } from './PartsSection';
import { FooterSection } from './FooterSection';

export class PartsPage extends React.Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <PageWrapper>
                    <Header />
                    <PartsSection />
					<FooterSection />
                </PageWrapper>
            </ThemeProvider>
        );
    }
}